import type { DirectoryRow } from "./hooks/useDirectorySearch"

/**
 * Add or remove one row from a picker's selection, keyed by id.
 *
 * Every directory picker (New Group, New Broadcast, Add Members) swaps its
 * whole `contacts` list out from under the selection whenever the scope tab
 * changes, a search is typed, or another page loads. A selection kept as
 * "ids that are currently in `contacts`" would lose anyone not on the page
 * that happens to be loaded right now. Keeping the row's data here, captured
 * at the moment it was ticked, is what lets the chips/count/details step read
 * from the selection alone and never from whatever page is on screen.
 */
export function toggleSelected(
  selected: Map<string, DirectoryRow>,
  row: DirectoryRow,
): Map<string, DirectoryRow> {
  const next = new Map(selected)
  if (next.has(row.id)) next.delete(row.id)
  else next.set(row.id, row)
  return next
}
